import { createSelector } from '@reduxjs/toolkit';
import { MAP_MARKUP } from '@rsos/capstone/src/constants/capabilities';
import { PREMIUM_MAP_MARKUP } from '@rsos/constants/permissions';

/**
 * Determines if the current user has both `MAP_MARKUP` capability and permissions enabled.
 * @param {Object} state - redux state
 * @param {Object} state.psaps - PSAPS reducer
 * @param {Object} state.sinatra - Sinatra reducer
 */
const checkEsriSketchWidgetAccessSelector = createSelector(
  state => state,
  state => {
    const isCapabilityEnabled =
      !!state.psaps?.currentPSAP?.activeCapabilities?.[MAP_MARKUP];

    const isPermissionEnabled =
      state.sinatra?.user?.currentRole?.permissions?.includes(
        PREMIUM_MAP_MARKUP,
      );

    return isCapabilityEnabled && isPermissionEnabled;
  },
);

export default checkEsriSketchWidgetAccessSelector;
